<ion-header>
  <div class="header-arc"></div>
  <svg width="414" height="24" viewBox="0 0 414 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M415 0H0V24C182.72 -17.7778 347.085 6.51852 415 24V0Z" fill="#FFFAE6" />
  </svg>
</ion-header>

<div class="th action-search-popup">

  <ion-row class="d-desc">
    <ion-col>
      <div class="d-block">
        <div class="title">
          <ion-icon (click)="dismiss()" name="arrow-back"></ion-icon>
          <ion-label class="finding_label">
            {{'Select action' | translate}}
          </ion-label>
        </div>
        <div>
          <ion-label class="add-action-btn" (click)="addActionforFinding()">
            <ion-icon name="add-circle-outline"></ion-icon>{{'Add action' | translate}}</ion-label>
        </div>

      </div>

    </ion-col>
  </ion-row>
</div>

<ion-content>

  <div class="add_action_card">
    <div class="action_list_main_div">
      <div class="action_list_div" *ngFor="let actions of addDuplicateFindingAction;let i=index;">
        <div>
          <ion-checkbox (ionChange)="addOldAction(actions,$event,i)" [(checked)]="actions.selected"></ion-checkbox>
        </div>
        <ion-row>
          <ion-col>
            <div class="action_summary_div">
              {{(actions.readMore) ? actions.actionSummary : actions.actionSummary | slice:0:70}}
              <u class="more_css" *ngIf="!actions.readMore && (actions.actionSummary).length > 70"
                (click)="actions.readMore=true">... more</u>
              <u class="more_css" *ngIf="actions.readMore && (actions.actionSummary).length > 70"
                (click)="actions.readMore=false">less</u>
            </div>
          </ion-col>

        </ion-row>
        <ion-row class="action_info_row">
          <ion-col>
            <div class="action-block">
              <ion-label class="action-label">{{actions?.assigned_to_name}}</ion-label>
              <ion-label class="action-title">Assiged to</ion-label>
            </div>
          </ion-col>
          <span class="border-btwn"></span>
          <ion-col>
            <div class="action-block">
              <ion-label class="action-label">{{actions?.due_date}}</ion-label>
              <ion-label class="action-title">Date</ion-label>
            </div>
          </ion-col>

        </ion-row>
      </div>
    </div>
  </div>
</ion-content>


<ion-footer class="findings-listing-footer" *ngIf="addOldFindingAction.length!=0">
  <ion-toolbar>
    <ion-button expand="block" fill="solid" class="btn-filled save-btn" (click)="selectAction()">
      {{'TREASURE_HUNT.ADD_ACTIONS' | translate}}
    </ion-button>
  </ion-toolbar>
</ion-footer>